import { render, staticRenderFns } from "./AIassessment.vue?vue&type=template&id=3df980b1&scoped=true&"
import script from "./AIassessment.vue?vue&type=script&lang=js&"
export * from "./AIassessment.vue?vue&type=script&lang=js&"
import style0 from "./AIassessment.vue?vue&type=style&index=0&id=3df980b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df980b1",
  null
  
)

export default component.exports